"use client";

import Form from "next/form";
import { resendWelcomeEmailAction } from "../actions";
import SubmitButton from "./SubmitButton";
import { User } from "@/api/users";

export default function ResendWelcomeEmailButton({ users }: { users: User[] }) {
  const handleAction = async (formData: FormData) => {
    resendWelcomeEmailAction(formData);
  };

  return (
    <Form action={handleAction}>
      {users.map((user) => (
        <input key={user.id} type="hidden" name="emails" value={user.email} />
      ))}
      <SubmitButton label="Resend Welcome Email" pendingLabel="Sending..." />
    </Form>
  );
}
